export enum __Permissions {
    EmailAccounts_Read = 'openbots.server.Infrastructure.EmailAccounts-Read',
    EmailAccount = 'Pages.Administration.IntakeAccount',
    EmailAccount_Create = 'Pages.Administration.IntakeAccount.Create',
    EmailAccount_Delete = 'Pages.Administration.IntakeAccount.Delete',
    EmailAccount_Edit = 'Pages.Administration.IntakeAccount.Edit',
    documentList = 'Pages.HumanTasks',
    document_create = 'Pages.HumanTasks.Create',
    document_delete = 'Pages.HumanTasks.Delete',
    documentEdit = 'Pages.HumanTasks.Edit',
    select_Case = 'Pages.CaseRecords.Create',
    templates_Delete = 'Pages.Administration.Forms.Delete',
    templateLibraries = 'Pages.Administration.TemplateLibraries',
    createTemplateLibrary = 'Pages.Administration.TemplateLibraries.Create',
    templateCreate = 'Pages.Administration.Forms.Create',
    documentScriberCreate = "Pages.Administration.DocumentScribeSections.Create",
    templateEdit = 'Pages.Administration.Forms.Edit',
    function = 'Pages.Functions',
    functionCall = 'Pages.Functions.Call',
    pipelines = 'Pages.Pipelines',
    createPipeline = 'Pages.Pipelines.Create',
    reports = 'Pages.Reports',
    formFields = 'FormFields',
    fieldCreate = 'Pages.Administration.FormFields.Create',
    fieldDelete = 'Pages.Administration.FormFields.Delete',
    fieldEdit = 'Pages.Administration.FormFields.Edit',
    fieldBoxCreate = 'Pages.Administration.FieldBoxes.Create',
    fieldBoxEdit = 'Pages.Administration.FieldBoxes.Edit',
    fieldBoxDelete = 'Pages.Administration.FieldBoxes.Delete',
    deleteTaskQueue = 'Pages.Administration.TaskQueues.Delete',
    editTaskQueue = 'Pages.Administration.TaskQueues.Edit',
    createTaskQueue = 'Pages.Administration.TaskQueues.Create',
    taskQueue = 'Pages.Administration.TaskQueues',
    OrganizationUnits = 'Pages.Administration.OrganizationUnits',
    ManageMembers = 'Pages.Administration.OrganizationUnits.ManageMembers',
    ManageOrganizationTree = 'Pages.Administration.OrganizationUnits.ManageOrganizationTree',
    ManageRoles = 'Pages.Administration.OrganizationUnits.ManageRoles',
    BalanceCredits = 'Pages.Administration.BalanceCredits',
    ChecklistTemplateItems = 'Pages.Administration.ChecklistTemplateItems',
    createCheckListTemplateItem = 'Pages.Administration.ChecklistTemplateItems.Create',
    deleteCheckListTemplateItem = 'Pages.Administration.ChecklistTemplateItems.Delete',
    editChecklistTemplateItem = 'Pages.Administration.ChecklistTemplateItems.Edit',
    checklistItemCreate = 'Pages.Administration.ChecklistItems.Create',
    deleteChecklistItem = 'Pages.Administration.ChecklistItems.Delete',
    editCheckListItem = 'Pages.Administration.ChecklistItems.Edit',
    CaseRecords = 'Pages.CaseRecords',
    createCaseRecord = 'Pages.CaseRecords.Create',
    deleteCaseRecord = 'Pages.CaseRecords.Delete',
    editCaseRecord = 'Pages.CaseRecords.Edit',
    caseRecordFieldsCustomizationses = 'Pages.CaseRecordFieldsCustomizationses',
    createCaseRecordFieldsCustomizationses = 'Pages.CaseRecordFieldsCustomizationses.Create',
    deleteCaseRecordFieldsCustomizationses = 'Pages.CaseRecordFieldsCustomizationses.Delete',
    editCaseRecordFieldsCustomizationses = 'Pages.CaseRecordFieldsCustomizationses.Edit',
    createRoles = 'Pages.Administration.Roles',
    batchMenuGrid = 'Pages.DocumentBatches',
    batchCreate = 'Pages.DocumentBatches.Create',
    batchEdit = 'Pages.DocumentBatches.Edit',
    batchDelete = 'Pages.DocumentBatches.Delete',
    users = 'Pages.Administration.Users',
    usersEdit = 'Pages.Administration.Users.Edit',
    UsersChangePermission = 'Pages.Administration.Users.ChangePermissions',
    CaseRecordTypesCreate = 'Pages.CaseRecordTypes.Create',
    CaseRecordTypesEdit = 'Pages.CaseRecordTypes.Edit',
    CaseRecordTypesDelete = 'Pages.CaseRecordTypes.Delete',
    reprocess_document = 'Pages.ReprocessPendingTask',
    events_create = 'Pages.Events.Create',
    events_Delete = 'Pages.Events.Delete',
    DocumentTags = 'Pages.Administration.DocumentTags',
    DocumentTags_edit = 'Pages.Administration.DocumentTags.Edit',
    DocumentTags_Create = 'Pages.Administration.DocumentTags.Create',
    DocumentTags_Delete = 'Pages.Administration.DocumentTags.Delete',
    Configration ='Pages.Administration.Users.ChangePermissions',
    WebhookSubscription = 'Pages.Administration.WebhookSubscription',
    WebhookSubscription_edit = 'Pages.Administration.WebhookSubscription.Edit',
    WebhookSubscription_Create = 'Pages.Administration.WebhookSubscription.Create',
    WebhookSubscription_Delete = 'Pages.Administration.WebhookSubscription.Delete',
    CaseTypeAssistants_Create = 'Pages.Administration.CaseTypeAssistants.Create',
    StarterKits = 'Pages.Administration.StarterKits.Create',
    knowraCreate = 'Pages.Administration.KnowledgeBase.Create',
    knowraEdit = 'Pages.Administration.KnowledgeBase.Edit',
    knowraDelete = 'Pages.Administration.KnowledgeBase.Delete',
    Location = 'Pages.Administration.Location',
    Location_Create = 'Pages.Administration.Location.Create',
    Location_Edit = 'Pages.Administration.Location.Edit',
    Location_Delete = 'Pages.Administration.Location.Delete',
    Provider = 'Pages.Administration.Provider',
    Provider_Create = 'Pages.Administration.Provider.Create',
    Provider_Edit = 'Pages.Administration.Provider.Edit',
    Provider_Delete = 'Pages.Administration.Provider.Delete',
    InsurancePayor = 'Pages.Administration.InsurancePayor',
    InsurancePayor_Create = 'Pages.Administration.InsurancePayor.Create',
    InsurancePayor_Edit = 'Pages.Administration.InsurancePayor.Edit',
    InsurancePayor_Delete = 'Pages.Administration.InsurancePayor.Delete',
    InsurancePlan = 'Pages.Administration.InsurancePlan',
    InsurancePlan_Create = 'Pages.Administration.InsurancePlan.Create',
    InsurancePlan_Edit = 'Pages.Administration.InsurancePlan.Edit',
    InsurancePlan_Delete = 'Pages.Administration.InsurancePlan.Delete',
    Patient = 'Pages.Administration.Patient',
    Patient_Create = 'Pages.Administration.Patient.Create',
    Patient_Edit = 'Pages.Administration.Patient.Edit',
    Patient_Delete = 'Pages.Administration.Patient.Delete',
    Payor = 'Pages.Administration.Payor',
    Payor_Create = 'Pages.Administration.Payor.Create',
    Payor_Edit = 'Pages.Administration.Payor.Edit',
    Payor_Delete = 'Pages.Administration.Payor.Delete',
    Lookups = 'Pages.Administration.Lookups',
    Lookups_Create = 'Pages.Administration.Lookups.Create',
    Lookups_Edit = 'Pages.Administration.Lookups.Edit',
    Lookups_Delete = 'Pages.Administration.Lookups.Delete',
    WorkItem = 'Pages.Administration.WorkItem',
    WorkItem_Create = 'Pages.Administration.WorkItem.Create',
    WorkItem_Edit = 'Pages.Administration.WorkItem.Edit',
    WorkItem_Delete = 'Pages.Administration.WorkItem.Delete',
}
